export default function registraEventoGoogleAnalytics(gtag, evento, categoria, label) {
    if (gtag){
        // Dispara o evento para o GA4
        gtag.event(evento, {
            event_category: categoria, // Categoria
            event_label: label, // Nome do PDF que está sendo baixado
        });
    }
}